import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Root from "./components/Root";
import { GlobalStyle } from "./GlobalStyle";
import { ThemeProvider } from "styled-components";
import Dashboard from "./pages/Dashboard";
import TablesTab from "./components/dashboard/TablesTab";
import Login from "./pages/Login";
import UserForm from "./components/dashboard/forms/UserForm";
import ProductForm from "./components/dashboard/forms/ProductForm";
import SubscriptionPaymentForm from "./components/dashboard/forms/SubscriptionPaymentForm";
import SubscriptionPlanForm from "./components/dashboard/forms/SubscriptionPlanForm";
import EnterpriseSubscriptionForm from "./components/dashboard/forms/EnterpriseSubscriptionForm";
import CustomerForm from "./components/dashboard/forms/CustomerForm";
import CountryForm from "./components/dashboard/forms/CountryForm";
import CurrencyForm from "./components/dashboard/forms/CurrencyForm";
import IssuerForm from "./components/dashboard/forms/IssuerForm";
import IssuerTable from "./components/dashboard/tables/IssuerTable";
import ProductTable from "./components/dashboard/tables/ProductTable";
import CustomerTable from "./components/dashboard/tables/CustomerTable";
import UserTable from "./components/dashboard/tables/UserTable";
import CountryTable from "./components/dashboard/tables/CountryTable";
import CurrencyTable from "./components/dashboard/tables/CurrencyTable";
import SubscriptionPaymentTable from "./components/dashboard/tables/SubscriptionPaymentTable";
import SubscriptionPlanTable from "./components/dashboard/tables/SubscriptionPlanTable";
import EnterpriseSubscriptionTable from "./components/dashboard/tables/EnterpriseSubscriptionTable";
import RoleForm from "./components/dashboard/forms/RoleForm";
import RoleTable from "./components/dashboard/tables/RoleTable";
import RolePrivilegeTable from "./components/dashboard/tables/RolePrivilegeTable";
import RolePrivilegeForm from "./components/dashboard/forms/RolePrivilegeForm";
import Protected from "./components/Protected";
import MarketPrice from "./components/dashboard/MarketPrice";
import PrimaryCD from "./components/dashboard/PrimaryCD";
import CPFMtable from "./components/dashboard/CPFMtable";
import MyTable from "./components/dashboard/tables/MyTable";
import CollapseTable from "./components/dashboard/tables/CollapsableTable";
import CPFMtableNew from "./components/dashboard/tables/CPFMtableNew";
import ApiUserTable from "./components/dashboard/tables/ApiUserTable";
import ApiUserForm from "./components/dashboard/forms/ApiUserForm";
import NCDTable from "./components/dashboard/tables/NCDTable";
import NonSlrMoneyMarket from "./components/dashboard/NonSlrMoneyMarket";

const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />
  },
  {
    path: '/dashboard',
    element: <Root />,
    children: [
      { 
        path: '',
        // index: true,
        element: <Protected component={<Dashboard />} />,
        children: [
          { index: true, element: <MarketPrice /> },
          { path: 'primary-cd', element: <PrimaryCD /> },
          { path: 'nonslr-money-market', element: <NonSlrMoneyMarket /> },
          { path: 'detail', element: <TablesTab /> },
          { path: 'user-form', element: <UserForm /> },
          { path: 'role-form', element: <RoleForm /> },
          { path: 'role-list', element: <RoleTable /> },
          { path: 'user-list', element: <UserTable /> },
          { path: 'product-form', element: <ProductForm /> },
          { path: 'product-list', element: <ProductTable /> },
          { path: 'country-form', element: <CountryForm /> },
          { path: 'country-list', element: <CountryTable /> },
          { path: 'issuer-list', element: <IssuerTable /> },
          { path: 'issuer-form', element: <IssuerForm /> },
          { path: 'customer-form', element: <CustomerForm /> },
          { path: 'customer-list', element: <CustomerTable /> },
          { path: 'currency-form', element: <CurrencyForm /> },
          { path: 'currency-list', element: <CurrencyTable /> },
          { path: 'subscription-payment-form', element: <SubscriptionPaymentForm /> },
          { path: 'subscription-payment-list', element: <SubscriptionPaymentTable /> },
          { path: 'subscription-plan-form', element: <SubscriptionPlanForm /> },
          { path: 'subscription-plan-list', element: <SubscriptionPlanTable /> },
          { path: 'enterprise-subscription-form', element: <EnterpriseSubscriptionForm /> },
          { path: 'enterprise-subscription-list', element: <EnterpriseSubscriptionTable /> },
          { path: 'role-privilege-form', element: <RolePrivilegeForm /> },
          { path: 'role-privilege-list', element: <RolePrivilegeTable /> },
          { path: 'cpfm-table', element: <CPFMtable /> },
          { path: 'cpfm', element: <CPFMtableNew /> },
          { path: 'my-table', element: <MyTable /> },
          { path: 'collapse-table', element: <CollapseTable /> },
          { path: 'api-user-list', element: <ApiUserTable /> },
          { path: 'api-user-form', element: <ApiUserForm /> },
          { path: 'ncd-data-list', element: <NCDTable /> },
        ],
      },
    ]
  },
  ,
]);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;

const theme = {
  colors: {
    text: '#0000',
    bg: '#F2FAFF',
    primary: '#1C79BB',
    secondary: '#F2FAFF',
    accent: '#056CB4',
    accent1: '#9ccff5',
    accent2: '#FF0000',
    error: '#ff6b6b',
    warning: '#FFCC00',
    success: '#10ac84',
    download: '#9b59b6',
  },
  media: {
    mobile: '768px',
    tab: '998px',
  }
}